// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-label[data-v-26086102]{color:var(--stan-primary-text-color);font-size:18px}", "",{"version":3,"sources":["webpack://src/components/charts/AnalyticsBarChart.vue"],"names":[],"mappings":"AAAA,8BAA8B,oCAAoC,CAAC,cAAc","sourcesContent":[".title-label[data-v-26086102]{color:var(--stan-primary-text-color);font-size:18px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
